import type { OrgPlanningProposal } from '../models/OrgPlanningChangeSet';

export interface PositionScenarioOption {
  readonly id: string;
  readonly scenarioId?: string;
  readonly headChangeSetId?: string;
  readonly title: string;
  readonly effectiveAt?: string;
  readonly variant: OrgPlanningProposal['variant'];
  readonly summary: Record<string, unknown>;
}

export function positionScenarioOptions(
  scenarios: readonly PositionScenarioOption[] | undefined,
): readonly PositionScenarioOption[] {
  return scenarios ?? [];
}

/** Selection is ID-authoritative; `new` and stale IDs never fall back to the newest draft. */
export function selectedPositionScenario(
  scenarios: readonly PositionScenarioOption[],
  selectedId: 'new' | string,
): PositionScenarioOption | null {
  return selectedId === 'new'
    ? null
    : scenarios.find((candidate) => candidate.id === selectedId) ?? null;
}

/**
 * Date inputs represent a planning day, but using midnight for "today" can
 * predate records imported later that same day. Capture now for a new same-day
 * scenario and preserve the exact instant once the durable scenario exists.
 */
export function positionScenarioEffectiveAt(
  selectedDate: string,
  existingEffectiveAt?: string,
  now = new Date(),
): string {
  if (existingEffectiveAt) return existingEffectiveAt;
  if (selectedDate === now.toISOString().slice(0, 10)) return now.toISOString();
  return new Date(`${selectedDate}T00:00:00.000Z`).toISOString();
}
